export class DocumentModel {
    constructor(data) {
        if(data) {
            this.id = (data.id)?data.id:null;
            this.version = (data.version)?data.version:null;
            this.createdAt = data.createdAt ?? null;
            this.updatedAt = (data.updatedAt)?data.updatedAt:null;
            this.isDeleted = (data.isDeleted)?data.isDeleted:false;
            this.documentName = (data.documentName)?data.documentName:null;
            this.moduleType = (data.moduleType)?data.moduleType:null;
            this.categoryOfUpload = (data.categoryOfUpload)?data.categoryOfUpload:null;
            this.uploaderName = (data.uploaderName)?data.uploaderName:null;
            this.label = (data.label)?data.label:'';
            this.refName = (data.refName)?data.refName:null;
            this.acceptedFileTypes = (data.acceptedFileTypes)?data.acceptedFileTypes:null;
            this.documentApproved = (data.documentApproved)?data.documentApproved:false;
            this.entityName = (data.entityName)?data.entityName:null;
            this.entityUniqueId = (data.entityUniqueId)?data.entityUniqueId:null;
            this.networkName = (data.networkName)?data.networkName:null;
            this.networkId = (data.networkId)?data.networkId:null;
            this.networkUniqueId = (data.networkUniqueId)?data.networkUniqueId:'';
            this.creatorFullName = (data.creatorFullName)?data.creatorFullName:null;
            this.creatorEmail = (data.creatorEmail)?data.creatorEmail:null;
            this.editorFullName = (data.editorFullName)?data.editorFullName:null;
            this.editorEmail = (data.editorEmail)?data.editorEmail:null;
            this.examProductId = (data.examProductId)?data.examProductId:null;
            this.qaModuleType = (data.qaModuleType)?data.qaModuleType:null;
            this.qaModuleTypeDescription = (data.qaModuleTypeDescription)?data.qaModuleTypeDescription:null;
        }
    }
}
